import { DataGrid, DataGridProps } from '@mui/x-data-grid'
import { Box, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { fsColors } from '../../../shared/constants'
import { useAppSelector } from '../../../store/hooks'

const FsDataTable = ({ rows, columns, processRowUpdate, isCellEditable }: DataGridProps) => {
  const { t } = useTranslation()
  const { currentTheme } = useAppSelector((state) => state.currentUser)
  const theme = useTheme()

  const localizedTextsMap = {
    noRowsLabel: t('no.rows'),
    columnMenuLabel: t('menu'),
    columnMenuSortAsc: t('sort.asc'),
    columnMenuSortDesc: t('sort.desc'),
    columnMenuUnsort: t('unsort'),
    columnMenuHideColumn: t('hide.column'),
    columnMenuManageColumns: t('manage.columns'),

    footerRowSelected: (count: any) =>
      count !== 1
        ? `${count.toLocaleString()} ${t('rows.selected')}`
        : `${count.toLocaleString()} ${t('row.selected')}`,

    footerTotalRowsCount: t('total.rows'),
  }

  const GridStyles = {
    '& .MuiDataGrid-columnHeader': {
      borderBottom: `3px solid`,
      borderColor: fsColors.fsGray.colors[1],
      position: 'sticky',
    },

    '& .MuiDataGrid-columnHeader:focus, .MuiDataGrid-cell:focus': {
      outline: 'none',
    },
    '& .MuiDataGrid-columnHeader:focus-within, .MuiDataGrid-cell:focus-within': {
      outline: 'none',
    },

    '& .MuiDataGrid-virtualScroller': {
      marginTop: '0 !important',
    },
    '& .MuiDataGrid-main': {
      overflow: 'visible',
    },

    '.MuiDataGrid-row.Mui-selected': {
      backgroundColor:
        currentTheme === 'light' ? fsColors.fsGray.colors[3] : fsColors.fsGray.colors[0],
      '&:hover': {
        backgroundColor:
          currentTheme === 'light' ? fsColors.fsGray.colors[3] : fsColors.fsGray.colors[0],
      },
    },
    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': { display: 'none' },
    '.MuiDataGrid-virtualScrollerContent': {
      maxHeight: 'calc(100vh - 330px) !important',
    },
    '.MuiDataGrid-virtualScrollerRenderZone': {
      maxHeight: 'calc(100vh - 330px)',
      overflow: 'scroll',
    },
  }

  return (
    <Box sx={{ overflowY: 'hidden', height: 'calc(100vh - 214px)' }}>
      <Box
        sx={{
          boxShadow: `1px 1px 5px 0px ${theme.palette.primary.main}80`,
          borderTopRightRadius: 7,
          borderBottomRightRadius: 7,
          borderBottomLeftRadius: 7,
          overflowY: 'hidden',
          maxHeight: 'calc(100vh - 214px)',
        }}
      >
        <DataGrid
          columns={columns}
          rows={rows}
          sx={GridStyles}
          /* TODO: It has issues like only visible rows in active page don't get selected 
        when you click on select all and row updates for selection are too costly.
        There are ways in pro (paid) version to fix these.
        As we are using free version currently, checkbox selection is removed for now.
         */
          // checkboxSelection
          // onRowSelectionModelChange={onRowSelectionModelChange}
          // rowSelectionModel={rowSelectionModel}
          processRowUpdate={processRowUpdate}
          isCellEditable={isCellEditable}
          // onProcessRowUpdateError={(e) => console.log(e)}
          disableRowSelectionOnClick
          localeText={localizedTextsMap}
          initialState={{
            pagination: { paginationModel: { pageSize: 20 } },
          }}
          pageSizeOptions={[10, 20, { value: rows ? rows.length : 100, label: t('all') }]}
          slotProps={{
            pagination: {
              labelRowsPerPage: t('ofa.rows.per.page'),
              labelDisplayedRows: ({ from, to, count }: { from: any; to: any; count: any }) =>
                `${from} - ${to} ${t('of')} ${count === -1 ? `${t('morethan')} ${to}` : count}`,
            },
          }}
        />
      </Box>
    </Box>
  )
}
export default FsDataTable
